import de from './de.json' with { type: 'json' };
import en from './en.json' with { type: 'json' };

export const partnersI18nNamespace = 'partners' as const;
export const partnersResources = { de, en } as const;
